module.exports = __webpack_public_path__ + "static/media/midknitetreks.23c4cb4c.png";